import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { shallowEqual } from "react-redux";
import FunnelRetentionChart from "./smartComponents/FunnelRetentionChart";

import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { actionCreators } from "./redux/retentionSagas";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import { useSelector, useDispatch } from "react-redux";
import LearnMore from "../../../../components/learnMore/learnMore";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import DatePicker from "./smartComponents/DatePicker";
import Filters from "./smartComponents/Filters";
import { UpdateButtons } from "./smartComponents/UpdateButtons";

const FunnelRetentionModule = ({ params, learnMore, title }) => {
  const { isLoading, isChartLoading, error, errorText } = useSelector((state) => {
    const { isLoading, isChartLoading, error, errorText } = state.funnelRetention;
    return { isLoading, isChartLoading, error, errorText };
  }, shallowEqual);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser({ data: params, updateFilters: false }));
  }, []);
  const content = () => {
    return (
      <div>
        <div className="edit-selections-bar">
          <div className="select-box">
            <p className="offers-title">
              Offers <span>(Select 6 Max)</span>
            </p>
            <Filters />
          </div>
          <div className="select-box">
            <p className="offers-title">Date Range</p>
            <CustomDateRanges />
          </div>
          <div className="date-select-box multi">
            <p className="offers-title">Date</p>
            <DatePicker />
          </div>
          <UpdateButtons />
        </div>
        {isChartLoading ? (
          <LoadingAnimation text="Getting fresh data, this may take a moment." />
        ) : (
          <div>
            {error ? <p className="error error--medium">{errorText}</p> : <FunnelRetentionChart />}
          </div>
        )}
      </div>
    );
  };
  return (
    <SectionToggle
      title={title}
      isLoading={isLoading}
      content={content()}
      learnMore={<LearnMore {...learnMore} title={title} html />}
    />
  );
};

export default FunnelRetentionModule;
